import { Route } from 'react-router-dom';
import { TracedRoutes } from '@comeon/error-reporter';
import {
	ROUTE_WE_SPIN_GAME_ROOM_ABS,
	ROUTE_WE_SPIN_GAME_ROOM_BUY_IN,
	ROUTE_WE_SPIN_GAME_ROOM_LIST_PLAYERS,
	ROUTE_WE_SPIN_GAME_ROOM_PREVIEW,
	ROUTE_WE_SPIN_GAME_ROOM_TOC
} from '../constants/we-spin-route-constants';
import WeSpinGameRoomBuyIn from './we-spin-game-room-buy-in';
import WeSpinGameRoomPlayers from './we-spin-game-room-players';
import WeSpinGameRoomTos from './we-spin-game-room-tos';
import { useMemo } from 'react';
import { getRelativePaths } from '~/utils/pathname';
import WeSpinGameRoomPreview from './we-spin-game-room-preview';

const CHILD_ROUTES = [
	ROUTE_WE_SPIN_GAME_ROOM_BUY_IN,
	ROUTE_WE_SPIN_GAME_ROOM_LIST_PLAYERS,
	ROUTE_WE_SPIN_GAME_ROOM_TOC,
	ROUTE_WE_SPIN_GAME_ROOM_PREVIEW
];
const WeSpinGameRoomRoutes = () => {
	const paths = useMemo(() => getRelativePaths(CHILD_ROUTES, ROUTE_WE_SPIN_GAME_ROOM_ABS), []);

	return (
		<TracedRoutes>
			<Route
				exact
				path={`${paths[ROUTE_WE_SPIN_GAME_ROOM_BUY_IN]}/:streamRef`}
				element={<WeSpinGameRoomBuyIn />}
			/>
			<Route
				exact
				path={`${paths[ROUTE_WE_SPIN_GAME_ROOM_LIST_PLAYERS]}/:streamRef`}
				element={<WeSpinGameRoomPlayers />}
			/>
			<Route exact path={`${paths[ROUTE_WE_SPIN_GAME_ROOM_TOC]}/:streamRef`} element={<WeSpinGameRoomTos />} />
			<Route
				exact
				path={`${paths[ROUTE_WE_SPIN_GAME_ROOM_PREVIEW]}/:streamRef`}
				element={<WeSpinGameRoomPreview />}
			/>
		</TracedRoutes>
	);
};

export default WeSpinGameRoomRoutes;
